import React, { FunctionComponent, useState, useEffect, useRef } from "react";
import RadioButtonsContent from "./RadioButtonsContent.model";
import styles from "./RadioButtons.module.scss";
import combineClasses from "helpers/combine-classes";

const RadioButtons: FunctionComponent<RadioButtonsContent> = (props) => {
    const { setFormFieldsState, formFieldsState, setRequiredFieldsEach, requiredFieldsEach, setCurrentAlerts, currentAlerts, setIsAlert, isAlert, resetFields } = props;
    const [fieldValue, setFieldValue] = useState("");
    const [checked, setChecked] = useState({ selectedOption: "" });
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (resetFields && ref.current) { ref.current.value = "", setFieldValue(""), setChecked({ selectedOption: "" }); }
    }, [resetFields]);

    const validateLength = (input: string) => {
        if (input.length > 0) {
            setCurrentAlerts(currentAlerts.filter(e => e !== props.requiredErrorMessage));
        }
    };

    const handleChange = (e: React.FormEvent<HTMLInputElement>) => {
        const el = e.target as HTMLInputElement;

        const includesAlias = requiredFieldsEach.length > 0 ? requiredFieldsEach.includes(props.alias) : false;
        if (props.mandatory && el.value.length > 0 && !includesAlias) {
            setRequiredFieldsEach([...requiredFieldsEach, props.alias]);
        }

        if (props.mandatory && el.value.length === 0 && includesAlias) {
            setRequiredFieldsEach(requiredFieldsEach.filter(e => e !== props.alias));
            setIsAlert(true);
        }

        validateLength(el.value);

        setFormFieldsState({ ...formFieldsState, [el.name]: el.value });
        if (ref.current) setFieldValue(ref.current.value);
    };

    const handleChecked = (e: React.FormEvent<HTMLInputElement>) => {
        const el = e.target as HTMLInputElement;
        setChecked({ selectedOption: el.value });
    };

    const alertClass = fieldValue === "" && props.mandatory && isAlert ? styles.alert : undefined;

    return (
        <div>
            <div className={styles.label_wrapper}>
                <span>{props.caption}</span> {props.mandatory ? (<span className={styles.mandatory}>*</span>) : null}
            </div>
            <div className={styles.radio_buttons} onChange={handleChange}>
                {/* Radio Buttons */}
                {props.preValues && props.preValues.length > 0 ? props.preValues.map((radioButton, index) => {
                    return (
                        <div key={index} className={styles.radio_button_wrapper}>
                            <input ref={ref} id={radioButton} checked={checked.selectedOption === radioButton} onChange={handleChecked} type="radio" value={radioButton} className={combineClasses([styles.radio_button, alertClass])} name={props.alias} />
                            <label htmlFor={radioButton}>{radioButton}</label>
                        </div>
                    );
                }) : null}
            </div>
        </div>
    );
};

export default RadioButtons;
